import React, { useState } from "react"
import Modal from "../../../../components/Modal"
import RadioInput from "../../../User/getAllUsers/components/RadioInput"

interface SortingProps {
  isOpen: boolean
  onClose: () => void
  sortBy: string
  sortOrder: boolean
  setSortBy: (sortBy: string) => void
  setSortOrder: (sortOrder: boolean) => void
}

const SORT_FIELDS = [
  { label: "Sıralama", value: "" },
  { label: "İzlenme", value: "parsedPayload.views" },
  { label: "Beğeni", value: "parsedPayload.likes" },
  { label: "Yorum", value: "parsedPayload.comments" },
  { label: "Paylaşım", value: "parsedPayload.shares" },
  { label: "Kaydetme", value: "parsedPayload.savings" },
  { label: "Etkileşim", value: "parsedPayload.interactions" },
  { label: "Tıklanma", value: "clicks" },
]

const Sorting: React.FC<SortingProps> = ({
  isOpen,
  onClose,
  sortBy,
  sortOrder,
  setSortBy,
  setSortOrder,
}) => {
  const [selectedSortBy, setSelectedSortBy] = useState(sortBy)
  const [selectedSortOrder, setSelectedSortOrder] = useState(sortOrder)

  return (
    <>
      {isOpen && (
        <div className="flex w-full items-center justify-center">
          <Modal
            classname="fixed inset-0 bg-gray-800 bg-opacity-50 p-3 flex items-center justify-end z-50"
            classname2="relative bg-white rounded-3xl w-full md:w-1/2 h-auto"
            onClick={onClose}
          >
            <div className="w-full p-4 h-full overflow-y-auto overscroll-contain">
              <div className="w-full">
                <h2 className="font-semibold text-2xl">Sırala</h2>
                <div className="border"></div>
              </div>

              {/* Sort By Field */}
              <div className="flex flex-col w-full justify-between items-center gap-4 mt-3 mb-3">
                <div className="w-full">
                  <label className="block mb-2 font-medium text-gray-700">Sıralama Kriteri</label>
                  <select
                    value={selectedSortBy}
                    onChange={(e) => setSelectedSortBy(e.target.value)}
                    className="w-full border border-gray-300 rounded-2xl px-3 py-2 text-sm bg-gray-100 focus:ring-0 focus:outline-none"
                  >
                    {SORT_FIELDS.map((field) => (
                      <option key={field.value} value={field.value}>
                        {field.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Sort Order */}
              <div className="flex w-full justify-between items-center gap-4 mt-3">
                <RadioInput
                  placeholder="Sıralama Yönü"
                  value={selectedSortOrder ? "ascending" : "descending"}
                  onChange={(e) => setSelectedSortOrder(e === "ascending")}
                  option1="ascending"
                  option2="descending"
                  label1="Azalan"
                  label2="Artan"
                />
              </div>

              <div
                className="flex flex-row justify-between w-full mt-24 py-4 space-x-24"
                style={{
                  boxShadow: "0px -12px 20px -10px rgba(0, 0, 128, 0.1)",
                }}
              >
                <button
                  className="text-blue h-12 rounded-full"
                  onClick={() => {
                    setSelectedSortBy("")
                    setSelectedSortOrder(true)
                  }}
                >
                  Temizle
                </button>
                <button
                  className="text-blue bg-blue-100 h-12 px-4 rounded-full"
                  onClick={() => {
                    setSortBy(selectedSortBy)
                    setSortOrder(selectedSortOrder)
                    onClose()
                  }}
                >
                  <span>Uygula</span>
                </button>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </>
  )
}

export default Sorting
